import gql from 'graphql-tag';

export const REMOVE_TOPIC = gql`
  mutation removeTopic($topicId: Int!) {
    topic {
      removeTopic(topicId: $topicId)
    }
  }
`;
